import {Component, Input, ChangeDetectionStrategy} from '@angular/core';


@Component({
  selector: 'app-user-rank',
  standalone: true,
  imports: [],
  templateUrl: './user-rank.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-rank.component.scss'
})
export class UserRankComponent{
  @Input()
  rank: number | undefined;

  @Input()
  points: number | undefined;

}
